import { en } from './en';
import { ru, type Dictionary } from './ru';

/**
 * Язык интерфейса админки: русский по умолчанию, английский по выбору.
 *
 * Обращение через объект, а не через функцию с ключом-строкой, даёт проверку
 * ключей на этапе сборки: опечатка в ключе — ошибка типов, а не пустая строка
 * на экране.
 *
 * Язык выбирается один раз при загрузке страницы, а смена языка её
 * перезагружает. Переключать на лету означало бы подписывать на язык каждый
 * компонент со строкой — ради действия, которое человек делает один раз.
 */
export type Language = 'ru' | 'en';

const STORAGE_KEY = 'faceta.language';

const dictionaries: Record<Language, Dictionary> = { ru, en };

/** Теги для Intl и атрибута lang: формат дат и чисел следует языку. */
const locales: Record<Language, string> = { ru: 'ru-RU', en: 'en-US' };

function readLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'ru' || stored === 'en') {
      return stored;
    }
  } catch {
    // Хранилище недоступно (приватный режим, запрет cookies) — язык по умолчанию.
  }
  return 'ru';
}

export const language: Language = readLanguage();
export const locale = locales[language];
export const t: Dictionary = dictionaries[language];

/** Запомнить язык и перезагрузить страницу, чтобы он применился везде. */
export function setLanguage(next: Language): void {
  if (next === language) {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Без хранилища выбор не переживёт перезагрузку — менять язык бессмысленно.
    return;
  }
  window.location.reload();
}
